import * as React from 'react';

import FilePowerpoint16 from './FilePowerpoint16';

export const filePowerpoint16 = () => <FilePowerpoint16 />;

export default {
    title: 'Icon|Fill|FilePowerpoint16',
    component: FilePowerpoint16,
    parameters: {
        notes: "`import FilePowerpoint16 from 'box-ui-elements/es/icon/fill/FilePowerpoint16';`",
    },
};
